import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../lib/api';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { ScrollArea } from '../components/ui/scroll-area';
import { STATUS_OPTIONS, getSubjectLabel } from '../lib/subjectFields';

export default function KanbanPage() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    API.get('/leads', { params: { limit: 500 } }).then(r => {
      setLeads(r.data.leads);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-64"><div className="w-6 h-6 border-2 border-primary border-t-transparent animate-spin" style={{borderRadius:'50%'}} /></div>;
  }

  const columns = STATUS_OPTIONS.filter(s =>
    !['archive'].includes(s.value)
  );

  return (
    <div className="space-y-4 fade-in" data-testid="kanban-page">
      <div>
        <h1 className="text-2xl font-heading font-bold text-[#0B1120]">Kanban</h1>
        <p className="text-sm text-muted-foreground">Vue par statut</p>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-4" data-testid="kanban-board">
        {columns.map(col => {
          const colLeads = leads.filter(l => l.status === col.value);
          return (
            <div key={col.value} className="kanban-column flex flex-col shrink-0">
              <div className="flex items-center justify-between mb-3 px-1">
                <div className="flex items-center gap-2">
                  <div className="w-2.5 h-2.5" style={{ backgroundColor: col.color, borderRadius: '50%' }} />
                  <span className="text-xs font-semibold uppercase tracking-wider">{col.label}</span>
                </div>
                <Badge variant="outline" className="text-[10px] h-5 px-1.5">{colLeads.length}</Badge>
              </div>

              <ScrollArea className="flex-1 bg-slate-50/80 border border-slate-200 p-2" style={{ maxHeight: 'calc(100vh - 200px)' }}>
                <div className="space-y-2">
                  {colLeads.map(lead => (
                    <Card
                      key={lead.id}
                      className="lead-card border shadow-sm cursor-pointer bg-white"
                      onClick={() => navigate(`/leads/${lead.id}`)}
                      data-testid={`kanban-card-${lead.id}`}
                    >
                      <CardContent className="p-3">
                        <p className="text-sm font-medium truncate">{lead.client_name}</p>
                        <div className="flex items-center gap-1.5 mt-1.5">
                          <Badge variant="outline" className="text-[9px] h-4 px-1">
                            {getSubjectLabel(lead.subject)}
                          </Badge>
                          <span className="text-[10px] text-muted-foreground">{lead.city}</span>
                        </div>
                        <div className="flex items-center justify-between mt-2">
                          <span className="text-[10px] text-muted-foreground">{lead.created_by_name}</span>
                          <span className="text-[10px] text-muted-foreground">
                            {new Date(lead.created_at).toLocaleDateString('fr-FR')}
                          </span>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                  {colLeads.length === 0 && (
                    <p className="text-xs text-muted-foreground text-center py-6">Aucun lead</p>
                  )}
                </div>
              </ScrollArea>
            </div>
          );
        })}
      </div>
    </div>
  );
}
